import { useEffect } from "react";

const SITE =
  (process.env.REACT_APP_BACKEND_URL || "").replace(/\/api\/?$/, "") ||
  (typeof window !== "undefined" ? window.location.origin : "");

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, path = "/" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — MONOE` : "MONOE — The space where business meets life.";
    const url = `${SITE}${path}`;
    document.title = fullTitle;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("property", "og:url", url);
    setCanonical(url);
  }, [title, description, path]);
}
